export default __webpack_public_path__ + "static/media/contact-website.005e39cb.svg";